import { gql } from '@apollo/client'

export const CONFIG_ATTRIBUTES = gql`
  fragment configAttributes on Config {
    name
    types {
      name
      label
      color
    }
  }
`

export const CONFIGS = gql`
  query {
    configs {
      result {
        ...configAttributes
      }
      totalResult
    }
  }
  ${CONFIG_ATTRIBUTES}
`